/* eslint-disable no-nested-ternary */
import { applyUrlParams } from '@surglogs/util'

import { createQuery } from './createQuery'
import {
  EndpointSpecInterfaceUrl,
  isEndpointSpecInterfaceUrlObject,
} from './Endpoint'

export const createEndpointUrl = (
  url: EndpointSpecInterfaceUrl,
  query?: Record<string, any>,
  opts?: Partial<{ baseUrl: string; arrayInFormatWithDuplicatedKeys: boolean }>,
) => {
  const pathname = isEndpointSpecInterfaceUrlObject(url)
    ? url.params
      ? applyUrlParams(url.endpoint, url.params)
      : url.endpoint
    : url

  return [
    opts?.baseUrl || '',
    pathname,
    query
      ? createQuery(query, false, opts?.arrayInFormatWithDuplicatedKeys)
      : '',
  ].join('')
}
